import { CSSObject } from '@chakra-ui/react';

export const BoxResultedWrapper: CSSObject = {
  mb: '0',
  px: '2',
  borderRadius: 'md',
  flex: '1',
  bg: 'rgba(34, 92, 161, 0.5)',
  boxShadow:
    '0px 4px 8px 0px rgba(0, 0, 0, 0.25), 0px 0px 20px 0px rgba(0, 216, 255, 0.15) inset, 0px 0px 0px 1px rgba(255, 255, 255, 0.05) inset',
};
export const RaceResultsHeader: CSSObject = {
  color: 'white',
  fontSize: 'xs',
  fontFamily: 'body',
  textTransform: 'uppercase',
  fontWeight: 'bold',
};
export const RunnerResultRow: CSSObject = {
  borderTop: '1px dashed rgba(255, 255, 255, 0.1)',
  borderBottom: '1px dashed rgba(0, 0, 0, 0.25)',
  py: '1.5',
  h: '12',
  _last: {
    borderBottom: 'none',
  },
};
export const RunnerDetails: CSSObject = {
  gap: '2',
};
export const RunnerPlace: CSSObject = {
  borderRadius: 'base',
  bg: 'beta.800',
  color: 'blackAlpha.800',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.5)',
  textTransform: 'uppercase',
  padding: '2',
  fontSize: '2xs',
  boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.25)',
  '&&': {
    h: '7',
    w: '9',
  },
  border: 'none',
};
export const RunnerNumber: CSSObject = {
  fontWeight: 'normal',
  fontSize: '2xs',
  color: 'white',
  pos: 'relative',
  bottom: '2px',
};
export const RunnerOddsContainer: CSSObject = {
  gap: '1',
};
export const RunnerOdds: CSSObject = {
  w: '12',
  h: '9',
  bg: 'blackAlpha.400',
  boxShadow:
    '0px 1px 0px 0px rgba(255, 255, 255, 0.15), 0px 0px 4px 0px rgba(0, 0, 0, 0.2) inset',
  border: 'none',
  borderRadius: 'base',
  color: 'whiteAlpha.300',
  fontWeight: 'black',
  fontFamily: 'body',
  fontSize: 'xs',
  textShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.15)',
};
export const Heading: CSSObject = {
  textTransform: 'capitalize',
  color: 'white',
  py: '2',
  alignItems: 'center',
  borderBottom: '1px dashed rgba(0, 0, 0, 0.15)',
  '.chakra-form-control': {
    flexDir: 'row-reverse',
    div: {
      fontSize: 'xs',
      fontWeight: 'medium',
    },
    '.chakra-switch__track': {
      bg: 'blackAlpha.600',
      boxShadow:
        '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 2px 2px 0px rgba(0, 0, 0, 0.25) inset',
      '.chakra-switch__thumb': {
        bg: 'white',
        '&[data-checked]': {
          bg: 'beta.300',
        },
      },
    },
  },
};
export const WinPlaceHeader: CSSObject = {
  py: '0',
  w: '12',
  color: 'white',
  fontSize: '2xs',
  fontWeight: 'bold',
};
export const FlexEventRule: CSSObject = {
  pt: '2',
  color: 'white',
};
